import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface IbcInputProps {
  onIbcChange: (value: string) => void;
  ibcValue: string;
  isEnabled: boolean;
}

export const IbcInput: React.FC<IbcInputProps> = ({
  onIbcChange,
  ibcValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="IBC"
      label="Enter IBC details:"
      placeholder="Enter International Building Code information..."
      value={ibcValue}
      onChange={onIbcChange}
      isEnabled={isEnabled}
    />
  );
};